import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';
import { AttendanceHistoryPoint } from '../../hooks/useStudentAttendanceHistory';

interface AttendanceChartProps {
  data: AttendanceHistoryPoint[];
  className?: string;
}

export function AttendanceChart({ data, className = '' }: AttendanceChartProps) {
  // Format data for recharts
  const chartData = data.map((point) => ({
    period: point.period_label,
    attendance: point.attendance_count,
  }));

  // Empty state
  if (chartData.length === 0 || chartData.every(d => d.attendance === 0)) {
    return (
      <Card className={`bg-[#221F1F] border-[#504A4A] ${className}`}>
        <CardContent className="py-12">
          <div className="text-center">
            <p className="text-text-primary text-lg mb-2">No attendance data yet</p>
            <p className="text-text-secondary text-sm">
              Start tracking classes to see progress over time
            </p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className={`bg-[#221F1F] border-[#504A4A] ${className}`}>
      <CardHeader>
        <CardTitle className="text-text-primary flex items-center gap-2">
          <span className="text-rollops-accent">📈</span>
          Attendance Trend
        </CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id="attendanceGradient" x1="0" y1="0" x2="1" y2="0">
                <stop offset="0%" stopColor="rgba(155, 20, 33, 1)" stopOpacity={1} />
                <stop offset="100%" stopColor="rgba(155, 20, 33, 0.6)" stopOpacity={0.6} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(169, 163, 163, 0.2)" />
            <XAxis
              dataKey="period"
              stroke="#A9A3A3"
              style={{ fontSize: '12px' }}
              angle={-45}
              textAnchor="end"
              height={80}
            />
            <YAxis
              stroke="#A9A3A3"
              style={{ fontSize: '12px' }}
              label={{ value: 'Classes', angle: -90, position: 'insideLeft', fill: '#A9A3A3' }}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: '#221F1F',
                border: '1px solid #504A4A',
                borderRadius: '8px',
                color: '#EBFFEE',
              }}
              labelStyle={{ color: '#A9A3A3' }}
            />
            <Line
              type="monotone"
              dataKey="attendance"
              stroke="url(#attendanceGradient)"
              strokeWidth={2}
              dot={{ fill: '#9B1421', r: 4 }}
              activeDot={{ r: 6 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
